import axios from "axios";
import { STORAGE_KEYS } from "../constants";

const validateReCaptchaToken = async (token) => {
  const response = await axios.post("/auth/validate-recaptcha", { token });

  return response.data;
};

const getAccessToken = () => {
  return sessionStorage.getItem(STORAGE_KEYS.TOKEN);
};

export const authService = {
  validateReCaptchaToken,
  getAccessToken,
};
